module.exports = "/images/vendor/flag-icon-css/flags/1x1/ps.svg?2992f9b92974b68d8a59bdcc30bfd63f";